import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxGridColumnDataType } from "./dx-grid-column-data-type";
/** Опции колонки грида. */
let DxGridColumn = class DxGridColumn {
    /** Опции колонки грида. */
    constructor() {
        /** Видимая \ скрытая колонка. */
        this._visible = true;
        /** Вся колонка лочится от каких либо действий со стороны пользователя. */
        this._disabled = false;
        /** Выравнивание заголовка: 'left', 'center', 'right' */
        this._headerJustify = 'left';
        /** Включает растягивание колонки мышью. */
        this._resizable = true;
        /** Ширина колонки в px. */
        this._width = 60;
        /** Автоматическое вычисление высоты строки в зависимости от высоты ячейки в данной колонке. */
        this._autoHeight = false;
        /** Активация фильрации по колонке. */
        this._filterable = false;
        /** Активация сортировки по колонке. */
        this._sortable = false;
        /** колонку можно перемещать */
        this._movable = true;
        /**
         * Участвует ли колонка в дефолтной сортировке грида.
         * Этот признак является зависимым от `sortable`. То есть для колонка сначала должна быть объявлена
         * как "сортируемая", а уже потом она может быть включена в список дефолтной сортировки.
         */
        this._usedInDefaultSort = false;
    }
    get isPinned() {
        return !!this._pinned;
    }
    get hasTooltip() {
        return !!this._tooltip;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get tooltip() {
        return this._tooltip;
    }
    set tooltip(value) {
        this._tooltip = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    get sortFilterField() {
        return this._sortFilterField;
    }
    set sortFilterField(value) {
        this._sortFilterField = value;
    }
    get dataType() {
        return this._dataType;
    }
    set dataType(value) {
        this._dataType = value;
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        this._visible = value;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get columnWidgetType() {
        return this._columnWidgetType;
    }
    set columnWidgetType(value) {
        this._columnWidgetType = value;
    }
    get pinned() {
        return this._pinned;
    }
    set pinned(value) {
        this._pinned = value;
    }
    get resizable() {
        return this._resizable;
    }
    set resizable(value) {
        this._resizable = value;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(value) {
        this._maxWidth = value;
    }
    get autoHeight() {
        return this._autoHeight;
    }
    set autoHeight(value) {
        this._autoHeight = value;
    }
    get filterable() {
        return this._filterable;
    }
    set filterable(value) {
        this._filterable = value;
    }
    get sortable() {
        return this._sortable;
    }
    set sortable(value) {
        this._sortable = value;
    }
    get sortDirection() {
        return this._sortDirection;
    }
    set sortDirection(value) {
        this._sortDirection = value;
    }
    get usedInDefaultSort() {
        return this._usedInDefaultSort;
    }
    set usedInDefaultSort(value) {
        this._usedInDefaultSort = value;
    }
    get movable() {
        return this._movable;
    }
    set movable(value) {
        this._movable = value;
    }
    get headerJustify() {
        return this._headerJustify;
    }
    set headerJustify(value) {
        this._headerJustify = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridColumn.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "tooltip", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_tooltip", void 0);
tslib_1.__decorate([
    jsonMember({ name: "property", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_property", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sortFilterField", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_sortFilterField", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dataType", constructor: DxGridColumnDataType, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxGridColumnDataType)
], DxGridColumn.prototype, "_dataType", void 0);
tslib_1.__decorate([
    jsonMember({ name: "visible", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_visible", void 0);
tslib_1.__decorate([
    jsonMember({ name: "disabled", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_disabled", void 0);
tslib_1.__decorate([
    jsonMember({ name: "columnWidgetType", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_columnWidgetType", void 0);
tslib_1.__decorate([
    jsonMember({ name: "pinned", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_pinned", void 0);
tslib_1.__decorate([
    jsonMember({ name: "headerJustify", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_headerJustify", void 0);
tslib_1.__decorate([
    jsonMember({ name: "resizable", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_resizable", void 0);
tslib_1.__decorate([
    jsonMember({ name: "width", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridColumn.prototype, "_width", void 0);
tslib_1.__decorate([
    jsonMember({ name: "maxWidth", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridColumn.prototype, "_maxWidth", void 0);
tslib_1.__decorate([
    jsonMember({ name: "autoHeight", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_autoHeight", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "cellClass", void 0);
tslib_1.__decorate([
    jsonMember({ name: "filterable", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_filterable", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sortable", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_sortable", void 0);
tslib_1.__decorate([
    jsonMember({ name: "movable", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_movable", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sortDirection", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridColumn.prototype, "_sortDirection", void 0);
tslib_1.__decorate([
    jsonMember({ name: "usedInDefaultSort", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridColumn.prototype, "_usedInDefaultSort", void 0);
DxGridColumn = tslib_1.__decorate([
    jsonObject
], DxGridColumn);
export { DxGridColumn };
